import { motion } from "framer-motion";
import { IonIcon, PngIcon, APP_ICONS } from "@/components/icons/AppIcon";
import SectionHeading from "@/components/home/SectionHeading";
import { fadeUp } from "@/components/home/motion";

const FEATURES = [
  {
    icons: [{ png: "trofee" }],
    title: "Trofeeën en tableau",
    desc: "Een trofeedossier met foto's, details van het schot, de gebruikte uitrusting en de omstandigheden. Kleinwild leg je vast als tableau. Delen kan als PDF-rapport of via een link.",
  },
  {
    icons: [{ ion: "map-outline" }],
    title: "Jachtgebieden",
    desc: "Teken de grens op de satellietkaart en beheer hoogzitten met schietsectoren, je jachtcombinatie, gezien wild, wildschade en takenlijst. Met weer, wind en verwachte wildactiviteit per gebied.",
  },
  {
    icons: [{ ion: "walk-outline" }],
    title: "Kaarten en routes",
    desc: "Al je trofeelocaties op de kaart, plus je eigen jachtkaart waarop je plekken bewaart en wandelroutes tekent.",
  },
  {
    icons: [{ ion: "stats-chart-outline" }],
    title: "Afschotplan",
    desc: "Per wildsoort en klasse het afgesproken aantal, wat er geschoten is en wat er nog resteert.",
  },
  {
    icons: [{ png: "nazoek" }],
    title: "Nazoek",
    desc: "Registreer een nazoek met laatste zichtpunt, nazoeker en hond. Je jachthonden leg je vast met details, gezondheid en jachtgeschiedenis.",
  },
  {
    icons: [{ png: "jachtuitrusting" }, { ion: "document-text-outline" }],
    title: "Jachtuitrusting en documenten",
    desc: "Wapens, munitie, optiek en voertuigen, plus je belangrijke documenten, overzichtelijk op één plek.",
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" data-testid="features-section" className="border-t border-[#2C2E29] py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <SectionHeading eyebrow="Functies" title="Alles van je jacht, rustig op één plek." />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {FEATURES.map((f, i) => (
            <motion.div
              key={f.title}
              data-testid={`feature-card-${i}`}
              variants={fadeUp} initial="hidden" whileInView="show"
              viewport={{ once: true, amount: 0.3 }} custom={i}
              className="rounded-2xl border border-[#2C2E29] bg-[#1C1D1A] p-7 transition-colors duration-300 hover:border-[#CAA362]/40"
            >
              <div className="icon-tile mb-6" data-testid={`feature-icon-${i}`}>
                {f.icons.map((ic) =>
                  ic.ion ? (
                    <IonIcon key={ic.ion} name={ic.ion} />
                  ) : (
                    <PngIcon key={ic.png} {...APP_ICONS[ic.png]} />
                  )
                )}
              </div>
              <h3 className="mb-2 font-serif-display text-xl font-semibold text-[#EAEBE7]">{f.title}</h3>
              <p className="text-sm leading-relaxed text-[#B5B8B0]">{f.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
